module.exports = __webpack_public_path__ + "img/loans.2f64003e.svg";